import React from 'react';
import {Col, Row} from 'react-bootstrap';
import Card from '../../elements/ReactBootstrap/Card';
import {
    getFscReportInfoUrl,
} from '../../../url';
import Content from '../../partials/Content.jsx';
import DateRangeSelectionWidget from "../../widgets/Report/Selection/DateRangeSelectionWidget.jsx";

const FscInfo = () => {
    return (<Content title="Детайлна справка - КФН">
        <Row>
            <Col>
                <Card outline header="Детайлна справка съгласно обобщените данни в справката на КФН">
                <DateRangeSelectionWidget
                    onSubmit={values => window.open(getFscReportInfoUrl(
                        values.startDateTime + ' 00:00:00',
                        values.endDateTime + ' 23:59:59',
                    ))} />
                </Card>
            </Col>
        </Row>
    </Content>);
};

export default FscInfo;
